import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import counterReducer from '../store/counter/counterSlice';
import authReducer from '../store/auth/authSlice';
import pageReducer from '../store/page/pageSlice';
import adminReducer from '../store/admin/adminSlice';
import transitionReducer from '../store/transitionSlice';
import tagsReducer from '../store/tagsSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    auth: authReducer,
    page: pageReducer,
    admin: adminReducer,
    // Имеется ввиду данные, которые нужно сохранить между страницами при переходе
    transition: transitionReducer,
    tags: tagsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [
          'transition/setGlobalModal',
          'transition/setUploadedFiles',
          'transition/setAvatarFile',
        ],
        // Ignore these paths in the state
        ignoredPaths: [
          'transition.globalModal',
          'transition.uploadedFiles',
          'transition.avatarFile',
          'auth.tokens',
        ],
      },
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
